import React from "react";
import { Stack, Tooltip } from "@mui/material";
import HotelIcon from "@mui/icons-material/Hotel";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import MedicationIcon from "@mui/icons-material/Medication";
import BoltIcon from "@mui/icons-material/Bolt";
import FiberNewIcon from "@mui/icons-material/FiberNew";

/**
 * Inline flags junto al nombre del paciente en la worklist.
 * Muestra iconos para: inpatient, discharged, high risk, polypharmacy, trigger, new member.
 */
export default function PatientFlags({ patient }) {
  const flags = [];

  if (patient.currentInpatient) {
    flags.push({ key: "inpatient", icon: <HotelIcon sx={{ fontSize: 14 }} />, tooltip: "Currently Admitted", color: "#DC2626" });
  }
  if (patient.recentlyDischarged) {
    flags.push({ key: "discharged", icon: <SwapHorizIcon sx={{ fontSize: 14 }} />, tooltip: "Recently Discharged", color: "#D97706" });
  }
  if (patient.laceScore === "HIGH" || (typeof patient.laceScore === "number" && patient.laceScore >= 16)) {
    flags.push({ key: "highRisk", icon: <FiberManualRecordIcon sx={{ fontSize: 10 }} />, tooltip: "High Risk", color: "#DC2626" });
  }
  if (patient.medications >= 5) {
    flags.push({ key: "polypharmacy", icon: <MedicationIcon sx={{ fontSize: 14 }} />, tooltip: "Polypharmacy (5+ meds)", color: "#D97706" });
  }
  if (patient.triggers > 0) {
    flags.push({ key: "trigger", icon: <BoltIcon sx={{ fontSize: 14 }} />, tooltip: "Clinical Trigger", color: "#EA580C" });
  }
  if (patient.newMember) {
    flags.push({ key: "newMember", icon: <FiberNewIcon sx={{ fontSize: 14 }} />, tooltip: "New Member", color: "#2563EB" });
  }

  if (flags.length === 0) return null;

  return (
    <Stack direction="row" alignItems="center" spacing={0.25} sx={{ ml: 0.5, display: "inline-flex" }}>
      {flags.map((f) => (
        <Tooltip key={f.key} title={f.tooltip} arrow>
          <span style={{ display: "inline-flex", color: f.color, lineHeight: 0 }}>{f.icon}</span>
        </Tooltip>
      ))}
    </Stack>
  );
}
